import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-644">
      <li className="flex" data-id="element-645">
        <span className="mr-2" data-id="element-646">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-647">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-648">
        <span className="mr-2" data-id="element-649">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-650">
          Photography
        </Link>
      </li>
      <li className="flex" data-id="element-651">
        <span className="mr-2" data-id="element-652">↑</span>
        <Link to="/writing" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-653">
          Editorial
        </Link>
      </li>
      <li className="flex" data-id="element-654">
        <span className="mr-2" data-id="element-655">↑</span>
        <Link to="/books" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-656">
          Books
        </Link>
      </li>
      <li className="flex" data-id="element-657">
        <span className="mr-2" data-id="element-658">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-659">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-660">
        <span className="mr-2" data-id="element-661">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-662">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;